import { createQueryKeys } from '@lukemorales/query-key-factory'

import {
  getAnnouncement,
  listPaginableAnnouncements,
  listSupportedTranslationLanguages,
} from '~/services/announcements-services'
import { getLastestActivity } from '~/services/dashboard-services'
import { type PlatformLanguage } from '~/utils/types/i18n'

export const announcementsQueries = createQueryKeys('announcements', {
  listSupportedTranslationLanguages: () => ({
    queryKey: ['supported-translation-languages'],
    queryFn: listSupportedTranslationLanguages,
  }),
  activityFeed: (language: string) => ({
    queryKey: ['activity-feed', language],
    queryFn: async () => await getLastestActivity(),
  }),
  getAnnouncement: (id: number) => ({
    queryKey: ['announcement', id],
    queryFn: async () => await getAnnouncement(id),
  }),
  announcementById: (id: number) => ({
    queryKey: ['announcement', id],
    queryFn: async () => {
      if (!id) throw new Error('Announcement ID is required')
      return await getAnnouncement(Number(id))
    },
  }),
  listPaginable: ({
    page,
    pageSize,
    filter,
    from,
    to,
    language,
  }: {
    page: number
    pageSize: number
    filter: string
    from: string
    to: string
    language: PlatformLanguage
  }) => ({
    queryKey: ['list-paginable', page, pageSize, filter, from, to, language],
    queryFn: async () =>
      await listPaginableAnnouncements(
        page,
        pageSize,
        filter,
        from,
        to,
        language,
      ),
  }),
})
